// RFC 5322 compliant email regex (requires at least one dot in domain)
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

// The organization identifier becomes a Keycloak group path, so these rules
// mirror the server exactly. The server lowercases and trims but does no other
// sanitising: an invalid identifier is rejected, never rewritten. These are now
// also the claim-parse rule — Claims.util.ts validates the organization segment
// of the platform_role leaf against them — not just the creation-form rule.
export const ORG_SLUG_MAX_LENGTH = 63;
export const ORG_SLUG_REGEX = /^[a-z0-9][a-z0-9-]{1,62}$/;
export const RESERVED_ORG_SLUGS = ['super_admin', 'admin', 'user'];
